import { useWriteContract } from "wagmi";
import { parseEther } from "viem";
import { SILO_NODE_ABI, SILO_NODE_CONTRACT } from "@/abis/silo-node";
import { larissaChain } from "@/configs/chain";

export function useSiloNodeActions() {
  const { writeContractAsync } = useWriteContract();

  const registerNode = async (nodeId: string, delegatorShareBps: number) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "registerNode",
      args: [nodeId, delegatorShareBps],
      chainId: larissaChain.id,
    });
    return { hash };
  };

  const addProviderStake = async (nodeId: string, amountLrs: string) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "addProviderStake",
      args: [nodeId],
      value: parseEther(amountLrs),
      chainId: larissaChain.id,
    });
    return { hash };
  };

  const removeProviderStake = async (nodeId: string, amountLrs: string) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "removeProviderStake",
      args: [nodeId, parseEther(amountLrs)],
      chainId: larissaChain.id,
    });
    return { hash };
  };

  const delegateToNode = async (nodeId: string, amountLrs: string) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "delegate",
      args: [nodeId],
      value: parseEther(amountLrs),
      chainId: larissaChain.id,
    });
    return { hash };
  };

  const undelegateFromNode = async (nodeId: string, amountLrs: string) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "undelegate",
      args: [nodeId, parseEther(amountLrs)],
      chainId: larissaChain.id,
    });
    return { hash };
  };

  const claimDelegatorReward = async (nodeId: string) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "claimDelegatorReward",
      args: [nodeId],
      chainId: larissaChain.id,
    });
    return { hash };
  };

  const claimProviderReward = async (nodeId: string) => {
    const hash = await writeContractAsync({
      address: SILO_NODE_CONTRACT,
      abi: SILO_NODE_ABI,
      functionName: "claimProviderReward",
      args: [nodeId],
      chainId: larissaChain.id,
    });
    return { hash };
  };

  return {
    registerNode,
    addProviderStake,
    removeProviderStake,
    delegateToNode,
    undelegateFromNode,
    claimDelegatorReward,
    claimProviderReward,
  };
}
